import { Link } from "react-router-dom";
import { ArrowRight, Moon, Sun, Mountain } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EDITIONS_IMAGES, EDITIONS_INTRO, SUPER_LUNE } from "@/data/editions";
import { useLocale } from "@/context/LocaleContext";

const EDITIONS = [
  { Icon: Moon, titre: "Super Lune", texte: `Création de nuit · ${SUPER_LUNE.prochaine.label.replace(" · soirée & nuit", "")}`, hash: "#super-lune" },
  { Icon: Sun, titre: "Solstice", texte: "Journée de création · 19 juin 2027", hash: "#solstice" },
  { Icon: Mountain, titre: "Tambours des Lieux", texte: "Une journée en plein air, sur un site choisi", hash: "#lieux" },
];

export const HomeEditionsEncart = () => {
  const { t } = useLocale();
  return (
  <section className="bg-card border-y border-sand-dark" data-testid="home-editions">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <Link to="/tambours/editions-limitees" data-testid="home-editions-image" className="block rounded-2xl overflow-hidden aspect-[4/5] group">
          <img src={EDITIONS_IMAGES.superLunePaysage} alt="Pleine lune se levant au-dessus des sapins, atelier éclairé dans la prairie" loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" />
        </Link>
      </Reveal>
      <div className="lg:col-span-7">
        <Reveal>
          <p className="eyebrow mb-5">{t("Créations signature")}</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-bark leading-tight">{t("Éditions limitées.")}</h2>
          <p className="mt-6 text-fumee leading-relaxed text-sm md:text-base max-w-xl">{EDITIONS_INTRO} Trois éditions, en petit groupe, qui ne sont pas proposées toute l'année.</p>
        </Reveal>
        <ul className="mt-9 grid sm:grid-cols-3 gap-4">
          {EDITIONS.map(({ Icon, titre, texte, hash }, i) => (
            <Reveal key={titre} delay={i * 0.08}>
              <Link to={`/tambours/editions-limitees${hash}`} data-testid={`home-editions-${hash.slice(1)}`} className="block h-full border border-sand-dark rounded-2xl p-5 bg-sand hover:border-terra transition-colors duration-300">
                <Icon className="w-5 h-5 text-terra" />
                <span className="block font-serif text-xl text-bark mt-3">{t(titre)}</span>
                <span className="block text-xs text-fumee mt-1.5 leading-relaxed">{t(texte)}</span>
              </Link>
            </Reveal>
          ))}
        </ul>
        <Reveal className="mt-9">
          <Link to="/tambours/editions-limitees" data-testid="home-editions-cta" className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-earth text-sand text-sm tracking-wide hover:bg-terra hover:text-earth transition-colors duration-300">{t("Découvrir les éditions limitées")} <ArrowRight className="w-4 h-4" /></Link>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
